export const editorOptions = {
  formats: [
    "header",
    //"size",
    "bold",
    "italic",
    "link",
    "list",
    "blockquote",
    /* "break",
    "code-block", */
  ],
};

export const textChange = (delta, source, html) => {
  if (delta && source) {
    return html
      .replace(/(<\w+[^>]*?)(\sstyle=["'].*?["'])([^>]*?>)/gi, "$1$3")
      .replace(/(<\?)h\d[^>]*?>/g, "$1>")
      .replace(/<hr[^>]*?>/g, "");
  }
};

export const customToolbar: Array<any> = [
  [{ header: [false, 3, 4] }],
  //[{ size: [false, "large", "huge"] }],
  ["bold", "italic"],
  ["link"],
  //[{ list: "ordered" }, { list: "bullet" }, "blockquote"],
  [ { list: "bullet" }, "blockquote"],
];
